<template>
  <section class="h-full gradient-form bg-gray-200 md:h-screen flex justify-center" dir="rtl">
  <div class="container py-12 px-6 h-full">
    <div class="flex justify-center items-center flex-wrap h-full g-6 text-gray-800">
      <div class="xl:w-8/12">
        <div class="block bg-white shadow-lg rounded-lg">
          <div class="lg:flex lg:flex-wrap g-0">
            <div class="lg:w-6/12 px-4 md:px-0">
              <div class="md:p-12 md:mx-6">
                 <div class="text-center">
                  <h4 class="text-xl font-semibold mt-1 mb-12 pb-1">با منوی دیجیتال، راهی جدید برای دیده شدن کسب و کار خود ایجاد کنید  </h4>
                </div>
                <form @submit.prevent="login">
            <div class="grid gap-2" >
            <!-- Email input -->
            <div class="space-y-1" >
                <Label class="text-gray-700" for="mobile" value="موبایل" />
                <InputIconWrapper>
                    <Input
                        id="mobile"
                        type="mobile"
                        class="block w-full border border-green-900"
                        placeholder="موبایل"
                        v-model="loginForm.mobile"
                        required
                        autofocus
                        autocomplete="username"
                        withIcon
                    />
                    <template #icon>
                        <PhoneIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                </InputIconWrapper>
            </div>
            <!-- Password input -->
            <div class="space-y-1">
                <Label class="text-gray-700" for="password" value="رمز" />
                <InputIconWrapper>
                    <template #icon>
                        <LockClosedIcon aria-hidden="true" class="w-5 h-5" />
                    </template>
                    <Input                      
                        withIcon
                        id="password"
                        type="password"
                        class="block w-full border border-green-900"
                        placeholder="رمز"
                        v-model="loginForm.password"
                        required
                        autocomplete="current-password"
                    />
                </InputIconWrapper>
            </div>
<!-- Captcha -->
            <div class="bg-white mt-2 ">
                <VueClientRecaptcha
                    :value="inputValue"
                    chars="123456789"
                    :hidelines="false"
                    custom-text-color="black"
                    @getCode="getCaptchaCode"
                    @isValid="checkValidCaptcha"
                >
             
                    <template #icon>
                    <span class="text-blue-500 ">بارگذاری مجدد</span>
                    </template>
                </VueClientRecaptcha>
       
                <input 
                
                    type="text"
                    v-model="inputValue"
                    placeholder="کد را وارد کنید"
                />
            </div>
            <!-- Remember me -->
            <div class="flex items-center justify-between">
                <!--<label class="flex items-center">
                    <Checkbox name="remember" v-model:checked="loginForm.remember" />
                    <span class="ml-2 text-sm text-gray-600">به خاطر بسپار</span>
                </label>
-->
                <router-link
                    :to="{ name: 'ForgotPassword' }"
                    class="text-sm text-blue-500 hover:underline"
                >بازیابی پسورد؟</router-link>
            </div>
          
            <!-- Login button -->
            <div>
                <Button
                    type="submit"
                    class="justify-center w-full gap-2"
                    :disabled="loginForm.processing"
                    v-slot="{ iconSizeClasses }"
                >
                    <LoginIcon aria-hidden="true" :class="iconSizeClasses" />
                    <span>ورود</span>
                </Button>
            </div>

            <!-- Register link -->
            <p class="text-sm text-gray-600 dark:text-gray-400 pb-2">
                آیا حساب دارید؟
                <router-link
                    :to="{ name: 'Register' }"
                    class="text-blue-500 hover:underline"
                >ثبت نام</router-link>
            </p>
        </div>
    </form>

              </div>
            </div>
            <div
              class="lg:w-6/12 flex items-center  lg:rounded-r-lg rounded-b-lg lg:rounded-bl-none"
              style="
                background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);
              "
            >
              <div class="text-white px-4 py-6 md:p-12 md:mx-6 ">
                <h4 class="text-xl font-semibold mb-6">تیم نرم افزار زرین پوز</h4>
                <p class="text-sm">
                  تیم زرین پوز متشکل از متخصصین تولید نرم افزار است، که از سال 1382 در این حوزه مشغول به فعالیت می باشند.
                </p>
                <h4 class="text-sm font-semibold mb-6 mt-6">نرم افزار زرین پوز</h4>
                <a href="https://zarinpos.com/" target="_blank" class="font-bold text-blue-900 hover:underline text-xl">www.zarinpos.com</a>
              </div>
             
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import VueClientRecaptcha from "vue-client-recaptcha";
import InputIconWrapper from '@/components/InputIconWrapper.vue'
import Label from '@/components/Label.vue'
import Input from '@/components/Input.vue'
import Button from '@/components/Button.vue'

import { PhoneIcon, LockClosedIcon, LoginIcon } from '@heroicons/vue/outline'

 export default {
  name: "Login",
  components: {VueClientRecaptcha,Button,Input,Label,PhoneIcon,LockClosedIcon,LoginIcon,InputIconWrapper},
  data() {
    return {
    inputValue: null,
    isValidCaptcha: false,
    loginForm :({
    mobile: '',
    password: '',
    message:'',
    loginError:false,
    remember: false,
    processing: false
     })
    }
  }, 
  methods: {
    getCaptchaCode(capthaResult) {
        /* you can access captcha code */
        console.log(capthaResult);
      },
      checkValidCaptcha(capthaResult) {
        /* expected return boolean if your value and captcha code are same return True otherwise return False */
        console.log("this is captha valid " + capthaResult);
        this.isValidCaptcha = capthaResult;
      },
      login() {
        //console.log("this is from click " + this.isValidCaptcha);
        if (this.isValidCaptcha) {
          //alert("Your Form Submited! captcha is valid");
          this.$store.dispatch('login', this.loginForm)
          .then(() => {
            //console.log("1234")
            //this.$router.push({name: 'Dashboard'})
            this.$router.push({name: 'HomePage'})
          }).catch(() => {
            //console.log("4321")
            
      })
        } else {
          alert("کد امنیتی وارد شده صحیح نمی باشد");
        }
       
        
      },
    }
  }
</script>